// @ts-nocheck
import type { LoginBoxProps } from 'src/@types'
import { Form } from 'antd'
import { Dialog } from 'antd-mobile'
import { createElement, useRef, useMemo } from 'react'
import clsx from 'clsx'
import { Input, Button } from 'src/component'
import {
  createForgetPw1Structure,
  createForgetPw2Structure,
  I18NS,
  PAGE_TYPE
} from 'src/utils'
import { useForgetUtils } from './forget.utils.ts'
import { getApi } from 'src/api/index.js'
import { RULE_MAP } from 'src/utils/pwdRule.js'
import { RuleModal } from 'src/component/ruleModal/index.jsx'
import s from './forgetPassword.module.scss'

export type ForgetPasswordProps = {
  /** 当前是否在验证阶段 */
  isVerify: boolean
}

export function ForgetPassword({ setRootState, getRootState, pageType, isApp }: LoginBoxProps) {

  const [ state, setState ] = livecloud.useStates(() => ({
    isVerify: true
  }))
  const form1Ref = useRef()
  const form2Ref = useRef()

  const [ pw1, pw2 ] = useMemo(() => [ createForgetPw1Structure(), createForgetPw2Structure() ], [])
  const {
    nextStep,
    finish
  } = useForgetUtils({ setState, form1Ref, form2Ref, setRootState })
  const { isVerify } = state

  const { isForgetPassword } = getRootState()

  //移动端校验弹窗
  const checkRule = async () => {
    const { password } = await form2Ref.current.validateFields()
    // 校验弹窗里的数据
    const res = await getApi('/login/page/pwd/getCondition')()
    if (!res.data) return
    const { conditions } = res.data
    const newRule = conditions?.map(t => ({ ...t, pass: false, fun: RULE_MAP?.filter(j => j.name === Number(t.name))[0]?.['fun'] }))
    const list = newRule?.map(t => ({
      ...t,
      pass: t.fun(password)
    }))
    if (list?.every(t => t.pass)) {
      finish()
    } else {
      Dialog.show({
        content: (
          <RuleModal value={password} rulePopperArr={newRule} isApp={isApp} />
        ),
        closeOnAction: true,
        actions:       [
          {
            key:  'cancel',
            text: '确认'
          }
        ]
      })
    }
  }

  return (
    <div
      className={`${s.root} forgetRoot`}
      style={{ display: isApp ? 'flex' : '', flexDirection: isApp ? 'column' : '' }}
    >
      {pageType === PAGE_TYPE.ForgotPassword
        ? <div className={s.emptyBack} />
        :
        <div
          className={`${s.back} forgetBack b-fx`}
          onClick={() => setRootState('isForgetPassword', false)}
        >
          <livecloud.icons.Icon
            size={16}
            href='LiveCloud-common-xiangzuojiantou'
          />
          {I18NS.RETURN_WORD}
        </div>
      }
      <Form
        name='basic1'
        ref={form1Ref}
        className={clsx(`${s.form} forgetForm-1 b-fx b-fx-col b-j-c`, isVerify || s.hide)}
        style={{ justifyContent: isApp ? 'space-evenly' : '' }}
        labelCol={{ span: 3 }}
        // initialValues={{ user: 'admin', verifyCode: '186282', email: '751774594@qq.com' }}
        autoComplete='off'
      >
        {pw1.map(t => createElement(Input, t))}
        <Button className='forgetNext' onClick={nextStep}>
          {I18NS.NEXT_STEP_WORD}
        </Button>
      </Form>
      <Form
        name='basic2'
        ref={form2Ref}
        className={clsx(`${s.form} forgetForm-2 b-fx b-fx-col b-j-c`, isVerify && s.hide)}
        labelCol={{ span: 3 }}
        // initialValues={{ password: '111111', password2: '111111'  }}
        autoComplete='off'
      >
        {pw2.map(t => createElement(Input, { ...t, isForgetPassword: isForgetPassword }))}
        {isApp && <div className={s.pwdTipLine}>{I18NS.COMPLETE_TIP}</div>}
        <Button className='forgetFinish'
          onClick={() => {
            if (isApp) {
              checkRule()
            } else {
              finish()
            }
          }}
        >
          {I18NS.FINISH_WORD}
        </Button>
      </Form>
    </div>
  )
}
